<template>
<div>
    <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>Workflows</v-tab>
        <v-tab>Subflows</v-tab>
        <v-tab>Processes</v-tab>
    </v-tabs>
  <div v-if="tab==0">
      <Workflow />
  </div>
  <div v-if="tab==1">
      <Subworkflow />
  </div>
  <div v-if="tab==2">
<Process />
  </div>

</div>
</template>

<script>
import Api from "@/services/Api";
import Workflow from '../components/workflow/Workflow.vue'
import Subworkflow from '../components/workflow/Subworkflow.vue'
import Process from '../components/workflow/Process.vue'

export default {
    components: {
        Process,
        Subworkflow,
        Workflow
    },
    data: () => ({
        headers: [{
                text: "Action",
                align: "center",
                sortable: false
            },
            {
                text: "Name",
                align: "center",
                value: "name",
            },
            {
                text: "Description",
                align: "center",
                value: "description",
            },
        ],
        search: '',
        tab: 0,
        wokflows: []
    }),
    created() {
        this.initialise()
    },
    methods: {
        initialise() {
            Api().get('/workflows').then(res => {
                this.workflows = res.data
            })
        }
    }
}
</script>
